export var Preferences = function(preferencesData) {
    var preferences = {};
    
    // Constructor
    if (preferencesData) {
        preferences.acceptMarketingEmail = preferencesData.acceptMarketingEmail;
        preferences.acceptMarketingSMS = preferencesData.acceptMarketingSMS;
        preferences.contactPreference = preferencesData.contactPreference;
        preferences.showContactInfo = preferencesData.showContactInfo;
        preferences.showContactInfoToFamilyAndFriends = preferencesData.showContactInfoToFamilyAndFriends;
        preferences.showContactInfoToFirstUpLine = preferencesData.showContactInfoToFirstUpLine;
        preferences.visibleInScannerLocator = preferencesData.visibleInScannerLocator;
        preferences.visibleInSponsorSearch = preferencesData.visibleInSponsorSearch;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return preferences;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/preferences.js
// module id = 32
// module chunks = 0